var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfidTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.44 17.66a2.53 2.53 0 0 0-3.1 1.79L24.1 39.02c-.3 1.1.08 2.2 1 2.78l.2-.71 5.24-19.58a2.53 2.53 0 0 1 3.1-1.79l19.55 5.24.72.2A2.44 2.44 0 0 0 52 22.9l-19.57-5.24Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.22 20.06a.42.42 0 0 1 .73-.42l2.1 3.63v.01c.12.2.05.46-.15.57l-1.18.68 1.38 2.4 5.8-3.36c.2-.11.45-.05.57.15v.01l1.76 3.03.02.05c.12.2.05.46-.15.58L30.13 34.3l1.36 2.36 18.06-10.44.05-.02.03-.03c.2-.11.46-.05.58.15l1.7 2.97.02.02c.12.2.05.46-.15.58l-17.12 9.89 1.25 2.16 6.8-3.92a.43.43 0 0 1 .05-.03c.2-.1.45-.03.56.16l1.8 3.12a.42.42 0 0 1-.73.42l-1.59-2.76-6.82 3.95a.42.42 0 0 1-.51-.08.42.42 0 0 1-.1-.1l-1.63-2.84a.42.42 0 0 1-.05-.27c0-.13.08-.27.2-.34L51 29.38l-1.3-2.26L31.54 37.6a.42.42 0 0 1-.58-.17l-1.73-3a.42.42 0 0 1-.07-.43.42.42 0 0 1 .25-.25l11.91-6.88-1.36-2.36-5.8 3.36a.42.42 0 0 1-.6-.2.42.42 0 0 1-.04-.06l-1.72-3a.43.43 0 0 1-.03-.05.42.42 0 0 1 .17-.54l1.17-.68-1.89-3.28Z",
    fill: "#039BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m44.48 41.01 4.35 1.17 2.12 3.67-.51 1.9-2.92-5.06-3.1 1.8 2.91 5.06-1.9-.51-2.12-3.67L44.48 41Z",
    fill: "#039BE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.07 30.68a2.53 2.53 0 0 1 1.79 3.1l-5.24 19.58a2.44 2.44 0 0 1-2.26 1.9l.19-.7 5.24-19.58a2.53 2.53 0 0 0-1.79-3.1l-19.55-5.24-.71-.2a2.44 2.44 0 0 1 2.77-1l19.56 5.24Z",
    fill: "#039BE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.92 33.38a.42.42 0 0 0-.42-.73l-3.62 2.1h-.01a.42.42 0 0 0-.16.58l.69 1.18-2.4 1.38-3.35-5.81a.42.42 0 0 0-.57-.15l-3.04 1.75a.4.4 0 0 0-.04.03.42.42 0 0 0-.16.57l6.91 11.98-2.36 1.37-10.42-18.07a.42.42 0 0 0-.03-.05.42.42 0 0 0-.6-.2l-2.96 1.72-.02.01a.42.42 0 0 0-.15.58l9.88 17.12L65.92 50 62 43.2a.43.43 0 0 0-.04-.05.42.42 0 0 0-.56-.14l-3.12 1.8a.42.42 0 0 0 .42.72l2.76-1.59 3.94 6.83c.1.17.3.24.47.2.05-.02.1-.03.14-.06l2.83-1.63a.42.42 0 0 0 .18-.2.42.42 0 0 0 0-.41l-9.88-17.1 2.26-1.31L71.88 48.4a.42.42 0 0 0 .6.14l2.98-1.73c.03 0 .05-.02.08-.03a.42.42 0 0 0 .2-.3.42.42 0 0 0-.09-.35l-6.87-11.91 2.35-1.37 3.36 5.81a.42.42 0 0 0 .62.12.4.4 0 0 0 .05-.02l3-1.73a.42.42 0 0 0 .05-.04.42.42 0 0 0 .12-.55l-.68-1.18 3.27-1.9Z",
    fill: "#039BE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m58.97 44.9-4.35-1.17-3.67 2.12-.51 1.9 5.06-2.92 1.8 3.1-5.07 2.93 1.9.51 3.67-2.12 1.17-4.36Z",
    fill: "#039BE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 69.72a2.53 2.53 0 0 1-1.8-3.1l5.25-19.57a2.44 2.44 0 0 1 2.26-1.9l-.2.7-5.24 19.58a2.53 2.53 0 0 0 1.79 3.1l19.56 5.24.7.2a2.44 2.44 0 0 1-2.77 1l-19.56-5.25Z",
    fill: "#039BE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.64 67.03a.42.42 0 0 0 .42.73l3.62-2.1h.02c.2-.12.26-.38.15-.58l-.68-1.18 2.4-1.38 3.34 5.8c.12.2.37.28.57.17l3.04-1.76.04-.03c.2-.12.28-.38.16-.58l-6.9-11.97 2.35-1.37 10.42 18.07.03.05a.42.42 0 0 0 .6.19l2.96-1.71.02-.02c.2-.11.27-.37.16-.57l-9.88-17.13 2.16-1.25 3.93 6.8c0 .02.02.03.03.05.12.2.37.26.57.14l3.11-1.8a.42.42 0 0 0-.42-.73l-2.75 1.6-3.94-6.83a.42.42 0 0 0-.48-.2c-.05.02-.1.03-.14.06l-2.83 1.63a.42.42 0 0 0-.18.2.42.42 0 0 0 .01.41l9.87 17.1-2.26 1.31L27.69 52a.42.42 0 0 0-.6-.14l-2.99 1.72a.42.42 0 0 0-.28.35.42.42 0 0 0 .1.34l6.87 11.91-2.36 1.36-3.35-5.8a.42.42 0 0 0-.62-.13.44.44 0 0 0-.05.03l-3 1.73a.41.41 0 0 0-.05.04.42.42 0 0 0-.13.55l.68 1.18-3.27 1.89Z",
    fill: "#039BE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m40.6 55.52 4.35 1.16 3.66-2.12.51-1.9-5.06 2.92-1.79-3.1 5.06-2.93-1.9-.51-3.67 2.12-1.17 4.36Z",
    fill: "#039BE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.12 82.75a2.53 2.53 0 0 0 3.1-1.79l5.24-19.57c.3-1.1-.08-2.2-1-2.78l-.19.71-5.24 19.57a2.53 2.53 0 0 1-3.1 1.8l-19.56-5.24-.71-.2c.03 1.1.8 1.97 1.9 2.26l19.56 5.24Z",
    fill: "#039BE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.34 80.35a.42.42 0 0 1-.73.42l-2.09-3.63v-.01a.42.42 0 0 1 .15-.57l1.18-.69-1.38-2.39-5.81 3.36a.42.42 0 0 1-.58-.16l-1.75-3.04a.4.4 0 0 1-.02-.05.42.42 0 0 1 .15-.57l11.98-6.92-1.37-2.36-18.05 10.44a.43.43 0 0 1-.05.02.42.42 0 0 1-.61-.13l-1.72-2.96v-.02a.42.42 0 0 1 .15-.58l17.11-9.89-1.25-2.17-6.8 3.93a.44.44 0 0 1-.05.03c-.2.1-.44.03-.56-.16l-1.8-3.12a.42.42 0 0 1 .73-.42l1.6 2.76 6.82-3.95a.4.4 0 0 1 .5.07c.04.04.08.07.1.12l1.63 2.83c.05.08.07.18.06.27a.44.44 0 0 1-.21.34l-17.1 9.88 1.3 2.26 18.15-10.48a.42.42 0 0 1 .58.17l1.73 3a.42.42 0 0 1 .08.43.42.42 0 0 1-.26.25l-11.9 6.88 1.35 2.36 5.81-3.36a.42.42 0 0 1 .6.2c0 .02.02.04.03.05l1.73 3 .03.06c.09.2.02.43-.17.54l-1.18.68 1.89 3.28Z",
    fill: "#039BE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m55.09 59.4-4.36-1.17-2.12-3.67.51-1.9 2.93 5.06 3.1-1.8-2.92-5.06 1.9.51 2.12 3.67-1.16 4.36Z",
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidTag);
export default ForwardRef;